module.exports = __webpack_public_path__ + "img/calendar.f4410bf2.svg";